(() => {
  if (window.CrossSellBase) return; // avoid redefining

  class CrossSellBase extends HTMLElement {
    // These will be overridden by subclasses:
    static wrapperSelector = '.cross-sell-wrapper';
    static sectionId = 'product-cross-sell';

    hasProducts = false;
    limit = 5;
    parentProductId = '';

    constructor() {
      super();

      // Variant-specific config:
      this.container = this.querySelector(this.constructor.wrapperSelector);
      this.sectionId = this.constructor.sectionId;
      this.parentProductId = this.dataset.productId;

      // Bind listener so we can remove it later
      this.onAjaxProductAdded = (event) => {
        if (event.detail.silently || !('formData' in event.detail)) return;

        this.container = this.container || this.querySelector(this.constructor.wrapperSelector);

        const formData = Object.fromEntries(event.detail.formData);
        const skipCrossSellPush = formData?.['properties[_skip_cross_sell_push]'];
        if (skipCrossSellPush === 'true') return;

        if (!this.hasProducts) {
          this.fetchProductCrossSellComplementary(this.renderProducts.bind(this));
        }
      };

      document.addEventListener('ajaxProduct:added', this.onAjaxProductAdded);
    }

    disconnectedCallback() {
      // clean up listener when element is removed
      if (this.onAjaxProductAdded) {
        document.removeEventListener('ajaxProduct:added', this.onAjaxProductAdded);
      }
    }

    fetchProductCrossSellComplementary(cb) {
      fetch(
        `${window.Shopify.routes.root}recommendations/products?product_id=${this.parentProductId}&limit=${this.limit}&section_id=${this.sectionId}&intent=complementary`,
      )
        .then((response) => response.text())
        .then(cb)
        .catch(console.error)
        .finally(() => {
          if (!this.hasProducts) {
            this.fetchProductCrossSellRelated(this.renderProducts.bind(this));
          } else if (this.container) {
            this.container.classList.add('cross-sell-visible');
          }
        });
    }

    fetchProductCrossSellRelated(cb) {
      fetch(
        `${window.Shopify.routes.root}recommendations/products?product_id=${this.parentProductId}&limit=${this.limit}&section_id=${this.sectionId}&intent=related`,
      )
        .then((response) => response.text())
        .then(cb)
        .catch(console.error);
    }

    renderProducts(responseText) {
      const doc = new DOMParser().parseFromString(responseText, 'text/html');
      const products = doc.body.querySelectorAll('.card--product');

      if (products.length > 0 && this.container) {
        this.container.insertAdjacentHTML('beforeend', doc.body.innerHTML);
        this.hasProducts = true;
        this.container.classList.add('cross-sell-visible');

        // Add GA tracking to each product card's add button
        const insertedProducts = this.container.querySelectorAll('.card--product');
        insertedProducts.forEach((product) => {
          const button = product.querySelector('[name="add"]');
          const productId = product.querySelector('input[name="product-id"]')?.value;

          if (button && productId) {
            button.addEventListener('click', () => this.sendToGa(productId));
          }
        });
      }
    }

    sendToGa(productId) {
      const productForm = document.querySelector(`#product-form-${productId}`);
      const id = productForm?.querySelector('input[name="id"]')?.value;

      if (!productForm || !id) {
        console.warn('GA: No product form / id found for cross-sell');
        return;
      }

      const productJson = productForm.querySelector(
        `#cross-sell-product-${id}`,
      )?.textContent;

      if (!productJson) {
        console.warn('GA: No cross-sell product found, atc event not added');
        return;
      }

      if (!window.analyzify) {
        throw new Error('Analyzify is not loaded. Cross-sell will not be pushed to dataLayer.');
      }

      const { product: productData } = JSON.parse(productJson);
      const [item] = window.analyzify.singleProdInfos(productData);
      const quantity = window.analyzify.findQuantity() || 1;
      const { detectedCurrency } = window.analyzify;

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'ee_add_to_cart',
        ecommerce: {
          currency: detectedCurrency,
          value: Number.parseFloat((item.price * quantity).toFixed(2)),
          analyzify_source: 'advanced',
          implementation_type: 'extension',
          items: [{ ...item, index: 1, quantity }],
        },
      });

      if (typeof pushDataLayer === 'function') {
        pushDataLayer('add_to_cart_cross_sell', {
          cross_sell_sku: productData.sku ?? 'no sku found',
        });
      } else {
        console.warn('pushDataLayer is not defined, custom event not pushed');
      }
    }
  }

  window.CrossSellBase = CrossSellBase;
})();